
/**
 * This file is auto-generated. Don't make any changes here — they will be owerwritten.
 */

// --------------------------------------------------------------
// Components
// --------------------------------------------------------------

import Carousel from '~/Views/Partials/Components/Carousel/Scripts/index.js';
import ContentAccordion from '~/Views/Partials/Components/ContentAccordion/Scripts/index.js';
import CookieBar from '~/Views/Partials/Components/CookieBar/Scripts/index.js';
import CookieSettings from '~/Views/Partials/Components/CookieSettings/Scripts/index.js';
import Menu from '~/Views/Partials/Components/Menu/Scripts/index.js';
import SiteHeader from '~/Views/Partials/Components/SiteHeader/Scripts/index.js';
import TableOfContents from '~/Views/Partials/Components/TableOfContents/Scripts/index.js';

export const components = [
    Carousel,
    ContentAccordion,
    CookieBar,
    CookieSettings,
    Menu,
    SiteHeader,
    TableOfContents
];

// --------------------------------------------------------------
// Pages
// --------------------------------------------------------------

import Root from '~/Views/Pages/Root/Scripts/index.js';
import Survey from '~/Views/Pages/Survey/Scripts/index.js';
import TwoColumns from '~/Views/Pages/TwoColumns/Scripts/index.js';

export const pages = [
    Root,
    Survey,
    TwoColumns
];
